import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import useChatStore from '@/stores/useChatStore'

export const MainNav = ({ onLinkClick }: { onLinkClick?: () => void }) => {
  const startNewSession = useChatStore((state) => state.startNewSession)
  const location = useLocation()

  const handleNewChatClick = () => {
    startNewSession()
    onLinkClick?.()
  }

  const navLinks = [
    {
      to: '/',
      label: 'New Chat',
      onClick: handleNewChatClick,
      isActive: (path: string) => path === '/' || path.startsWith('/session/'),
    },
    {
      to: '/history',
      label: 'Session History',
      onClick: onLinkClick,
      isActive: (path: string) => path === '/history',
    },
    {
      to: '/organizations',
      label: 'Organizations',
      onClick: onLinkClick,
      isActive: (path: string) => path.startsWith('/organizations'),
    },
    {
      to: '/agents',
      label: 'Agents',
      onClick: onLinkClick,
      isActive: (path: string) => path.startsWith('/agents'),
    },
  ]

  return (
    <>
      {navLinks.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          onClick={link.onClick}
          className={cn(
            'transition-colors hover:text-foreground/80',
            link.isActive(location.pathname)
              ? 'text-foreground'
              : 'text-foreground/60',
          )}
        >
          {link.label}
        </Link>
      ))}
    </>
  )
}
